import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Checkbox, Message, Select, Typography } from "@arco-design/web-react";

import { FetchApi, SaveApi } from "../../Api/AuthenticatedApi";

const { Text } = Typography;

const HOURS = Array.from({ length: 24 }, (_, h) => ({
  label: String(h).padStart(2, "0") + ":00",
  value: h,
}));

// Replaces the old "coming soon" placeholder: a real send window for drip
// sequences (quiet hours), stored in org settings (UTC), honored by the promoter.
export default function SequenceSendWindow() {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [record, setRecord] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [startHour, setStartHour] = useState(9);
  const [endHour, setEndHour] = useState(17);

  useEffect(() => {
    FetchApi(getAccessTokenSilently, "/api/settings/organization",
      (r) => {
        setRecord(r);
        const s = parseInt(r.settings?.sequence_send_start_hour, 10);
        const e = parseInt(r.settings?.sequence_send_end_hour, 10);
        if (!isNaN(s) && !isNaN(e) && s !== e) {
          setEnabled(true); setStartHour(s); setEndHour(e);
        }
      },
      () => navigate("/login"),
      () => Message.error("Failed to load settings"));
  }, [getAccessTokenSilently, navigate]);

  const save = () => {
    if (!record) return;
    if (enabled && startHour === endHour) {
      Message.warning("Start and end hours must differ");
      return;
    }
    SaveApi(getAccessTokenSilently, "/api/settings/organization/settings",
      (r) => { setRecord(r); Message.success("Send window saved"); },
      () => navigate("/login"),
      () => Message.error("Failed to save send window"),
      {
        name: record.name,
        org_hash: record.org_hash,
        settings: {
          ...(record.settings || {}),
          sequence_send_start_hour: enabled ? String(startHour) : "",
          sequence_send_end_hour: enabled ? String(endHour) : "",
        },
      });
  };

  return (
    <div>
      <Text type="secondary">
        Limit when drip-sequence emails go out (in UTC) — e.g. avoid sending overnight.
        Steps that come due outside the window wait for the next in-window check.
      </Text>

      <div style={{ marginTop: 16 }}>
        <Checkbox checked={enabled} onChange={setEnabled}>
          Only send sequence emails between set hours
        </Checkbox>
      </div>

      {enabled && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
          <Text>From</Text>
          <Select style={{ width: 110 }} value={startHour} onChange={setStartHour} options={HOURS} />
          <Text>to</Text>
          <Select style={{ width: 110 }} value={endHour} onChange={setEndHour} options={HOURS} />
          <Text type="secondary">UTC</Text>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <Button type="primary" onClick={save}>Save</Button>
      </div>
    </div>
  );
}
